import React, { useEffect, useReducer, useState } from "react"
import AddNewLocation from "./AddNewLocation"
import { ServerRequestProtected } from "../../../../utils/ServerDataRequest"
import NotificationHandler from "../../../../utils/NotificationHandler"
import { enumUtil } from "../../../../utils/Enum"
import Loader from "../../../shared/Loader/Loader"
import SearchHeader from "../../Shared/SearchHeader"
import Card from "../../Shared/Card"
import Table from "../../Shared/Table"
import GridColumnHeader from "../../Shared/GridColumnHeader"
import Pagination from "../../../shared/Pagination/Pagination"
import DeleteReduxDropDown from "../../../shared/DeleteReduxDropDown"
import { useDispatch, useSelector } from "react-redux"
import isNull from "../../../../utils/NullChecking"
import { GeneralDropDowns } from "../../../../actions/GeneralPatientActions"
import handleCopyText from "../../../shared/CopyData"
import { connect } from "react-redux"
import { FindSecondChild } from "../../../../utils/FindMenuOption"
import usePagination from "../../../../customhooks/usePagination"
const Location = (props) => {
    let IsDeleteAllowed = FindSecondChild('Setup', 'Account', 'Location')?.IsDeleted
    //Settings contains default values for Per Page  in Grid and view of Page.
    const { type, Settings } = { ...props };
    const { paginationSection, PerPage, PageNo, TotalPages, handlePageClick, PreviousPage, NextPage, handleFingByCreteria, setTotalPages, handleSelectData } = usePagination(Settings.PaginationDefaultRows);

    const API_URL = enumUtil.controller.General
    const [isOpenLocation, setIsOpenLocation] = useState(false)
    const [LocationData, setLocationData] = useState([]);
    const [LocationID, setLocationID] = useState();
    const [searchParam, setSearchParam] = useState();
    const [EnterParam, setEnterParam] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [isClose, setIsClose] = useState('12');
    const [show, setShow] = useState(Settings?.DefaultPageView === "Card View" ? true : false);
    const [totalCounts, setTotalCounts] = useState(false)
    const [copiedText, setCopiedText] = useState({});
    let DropDowns = useSelector(state => state.GeneralDropDownsReducer)
    ////////====GridColumnHeader=========//////////
    const [gridHeader, handleGridHeader] = useReducer((prev, next) => {
        return { ...prev, ...next }
    }, { defaultData: '', activeSortIcon: '' })
    //////////////////////////////////////////////
    const searchButton = {
        AddNew: true,
        Excel: false,
        PDF: false,
        Delete: false,
        Filter: false,
        View: true  // set true if want to display cards as well
    }
    const [searchParamType, setSearchparamType] = useState("");

    // const [prm, setPrm] = useState('');

    //For Pagination
    // const [PerPage, setPerPage] = useState(Settings?.PaginationDefaultRows);
    // const [PageNo, setPageNo] = useState(1);
    // const [TotalPages, setTotalPages] = useState();
    // const handlePageClick = (page) => { setPageNo(page); }
    // const PreviousPage = () => { if (PageNo > 1) setPageNo(PageNo - 1); }
    // const NextPage = () => { if (PageNo < TotalPages) setPageNo(PageNo + 1); }
    // const handleFingByCreteria = (e) => {
    //     setPerPage(e.target.value)
    //     setPageNo(1)
    // }
    const [npiModal, setNpiModal] = useState(false)
    const onCloseProocedNpi = () => {
        setNpiModal(false)
    }
    const proceedHeader = () => {
        return <p className="heading">Proceed with NPI Registry</p>;
    };
    const handleCopy = (row, type) => {
        let name = `${row}-${type}`;
        console.log("Name", name)
        handleCopyText(type);
        setCopiedText({ ...copiedText, [name]: true });
        setTimeout(() => {
            setCopiedText({ ...copiedText, [name]: false });
        }, 300)
    }

    /////////////////
    const columns = [


        {
            key: 'ShortName',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'bi bi-telephone-fill'} headerName={'Short Name'} sortIcon={true} type={'string'} colKey={'ShortName'} data={LocationData} setData={setLocationData} />),
            width: 150,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <button className="btn btn-link w-100 p-0" >
                        <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
                            <div className="validation_message" onClick={() => AddLocation(row.LocationID)}>{row.ShortName} </div>

                            {/* <div className="icon_copy">
                            <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LocationID, row.ShortName)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div> */}
                            {/* {copiedText[`${row.LocationID}-${row.ShortName}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>} */}
                        </div>
                    </button>
                );
            },
        },
        {
            key: 'Name',
            width: 300,
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-location'} headerName={'Location Name'} sortIcon={true} type={'string'} colKey={'Name'} data={LocationData} setData={setLocationData} />),
            resizable: true,
            // renderCell: ({ row }) => {
            //     return (
            //         <button className="btn  w-100 p-0" >
            //             <div className="d-flex copy_icon_hover justify-content-between w-100 align-items-center copy_icon gap-1">
            //                 {/* <div className="validation_message" onClick={() => AddLocation(row.LocationID)}>{row.Name} </div> */}
            //                 <div className="icon_copy">
            //                     <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LocationID, row.Name)}></i>
            //                     <p class="tool_tip xsm_text text-light">Copy</p>
            //                 </div>
            //                 {copiedText[`${row.LocationID}-${row.Name}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
            //             </div>
            //         </button>
            //     );
            // },
        },
        {
            key: 'POS',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-user-profile'} headerName={'POS'} sortIcon={true} type={'number'} colKey={'POS'} data={LocationData} setData={setLocationData} />),
            // width: 150,
            resizable: true,
        },
        {
            key: 'NPI',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-card'} headerName={'NPI'} sortIcon={true} type={'number'} colKey={'NPI'} data={LocationData} setData={setLocationData} />),
            width: 120,
            resizable: true,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.NPI}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LocationID, row.NPI)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.LocationID}-${row.NPI}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            },
        },
        {
            key: 'TaxonomyCode',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-user-profile'} headerName={'Taxonomy Code'} sortIcon={true} type={'number'} colKey={'TaxonomyCode'} data={LocationData} setData={setLocationData} />),
            width: 150,
            resizable: true,
        },
        {
            key: 'PhoneNumber',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'bi bi-telephone-fill'} headerName={'Phone Number'} sortIcon={true} type={'number'} colKey={'PhoneNumber'} data={LocationData} setData={setLocationData} />),
            width: 150,
            resizable: true,
        },

        {
            key: 'Address',
            name: (<GridColumnHeader gridHeader={gridHeader} handleGridHeader={handleGridHeader}
                iconName={'icon-address'} headerName={'Address'} sortIcon={true} type={'number'} colKey={'Address'} data={LocationData} setData={setLocationData} />),
            resizable: true,
            flex: 1,
            renderCell: ({ row }) => {
                return (
                    <>
                        <div className="align-items-center pri_ins copy_icon copy_icon_hover d-flex gap-1 justify-content-between patient_col w-100">
                            <div className="copy_icon validation_message">
                                {row.Address}
                            </div>
                            <div className="icon_copy">
                                <i className='icon-Icon-ionic-ios-copy' onClick={() => handleCopy(row.LocationID, row.Address)}></i>
                                <p class="tool_tip xsm_text text-light">Copy</p>
                            </div>
                            {copiedText[`${row.LocationID}-${row.Address}`] ? <p className={`xsm_text copied_text d-block`} >Copied to clipboard</p> : <></>}
                        </div>
                    </>
                );
            }
        },
    ];
    ///////////
    const LoadData = (param, types) => {
        setIsLoading(true)
        // setLocationData([])
        if (types) {
            setSearchparamType(types)
        } else {
            setSearchparamType("")
        }
        const SearchPageNo = !param;
        ServerRequestProtected(API_URL + "/FindBySingleCriteria", 'post', {
            "TableName": enumUtil.enumAPITableName.Location,
            "SearchParam": param, // prm in case of Taxonomy
            "PerPage": PerPage,
            "PageNo": SearchPageNo ? PageNo : 1,
        }).then((response) => {
            setTotalCounts(response.Rows.length)
            setIsLoading(false)
            setLocationData(response.Rows)
            handleGridHeader({ defaultData: response.Rows })
            setTotalPages(response.count.NumOfPages);
            if (type && type === "Wizard") {
                if (response.Rows?.length == 0 && isNull(searchParamType)) {
                    setIsOpenLocation(true)
                }
            }
        }).catch((error) => {
            setLocationData([])
            setTotalCounts(0)
            setIsLoading(false)
            if (type && type === "Wizard") {
                if (LocationData?.length == 0 && isNull(searchParamType)) {
                    setIsOpenLocation(true)
                }
            }
        })
    }
    const SearchOnEnter = (e) => {
        if (e.key === "Enter") {
            SearchByParam(searchParam, "searchParam")
        }
    }

    useEffect(() => {
        LoadData(searchParam);
    }, [PerPage, PageNo]) // prm in case of taxonomy
    useEffect(() => {
        LoadData(searchParam);
    }, [isClose])
    // open provider 
    const AddLocation = (ID) => {
        setIsOpenLocation(true)
        setNpiModal(true)
        setLocationID(ID)
    }
    const CloseLocation = () => {
        setIsOpenLocation(false)
        setNpiModal(false)
    }
    const DeleteLocation = () => {
        setIsOpenLocation(false)
        setIsClose((Math.random()));
        // console.log(DropDowns);
        // let DelLoc = DeleteReduxDropDown(LocationID, DropDowns.Location);
        // // DropDowns.Location = DelLoc
        // dispatch(GeneralDropDowns({ ...DropDowns, Location: DelLoc }));

    }
    let PopupScreen = "";
    if (isOpenLocation) {
        PopupScreen = <AddNewLocation isOpenLocation={isOpenLocation} onClose={CloseLocation}
            onDeleteLocation={DeleteLocation} LocationID={LocationID}
            npiModal={npiModal} di proceedHeader={proceedHeader} onCloseProocedNpi={onCloseProocedNpi} type={type}
        />
    }
    const CardView = () => {
        setShow(true)
        setNpiModal(false)
    };
    const TableView = () => {
        setShow(false)
        // setPerPage(10)
    };
    // useEffect(() => {
    // }, [LocationData])
    const rowClass = () => { return "row-bg" }
    const handleExcel = () => { }
    const handlePdf = () => { }
    const handleFilter = () => { }
    const handleDelete = () => { }
    const SearchByParam = () => {
        if (!isNull(searchParam)) {
            LoadData(searchParam)
        } else {
            LoadData()
        }
    }
    const handleClearSearch = () => {
        console.log("Clear Search, location");
        
        setSearchParam('')
    }

    const LocationBody = () => {
        return (
            <>
                <div className={show ? 'container-fluid action-row br-bottom-1 br-clr' : 'container-fluid action-row br-clr'}>
                    <div className="row justify-content-between">
                        <div className="col-4 form-rounded">
                            <div className="input">
                                <div className='input-group hk-input-search'>
                                    <input type="text" className='form-control fc-xs'
                                        placeholder='Search by name or id…'
                                        onChange={(e) => setSearchParam(e.target.value)}
                                        onKeyDown={SearchOnEnter}
                                        value={searchParam} />
                                    {searchParam?.length > 0 ?
                                        <span className="input-group-text" id="basic-addon2" onClick={handleClearSearch}>
                                            <i className="bi bi-x"></i>
                                        </span> : <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                            <i className="bi bi-search"></i>
                                        </span>}
                                    {/* <span className="input-group-text" id="basic-addon2" onClick={SearchByParam}>
                                        <i className="bi bi-search"></i>
                                    </span> */}
                                </div>
                            </div>
                        </div>
                        <div className="col-8 ps-0">
                            <SearchHeader
                                AddNew={AddLocation}
                                Excel={handleExcel}
                                PDF={handlePdf}
                                Delete={handleDelete}
                                Filter={handleFilter}
                                cardView={CardView}
                                tableView={TableView}
                                show={show}
                                searchButton={searchButton}
                                Key={612}
                                Name={'Location'}
                                Counts={totalCounts}
                            />
                        </div>
                    </div>
                </div>
                {show ?
                    <>
                        <Card
                            AddNew={AddLocation}
                            Data={LocationData}
                            API_URL={API_URL}
                            TableName={enumUtil.enumAPITableName.Location}
                            handleDelete={DeleteLocation}
                            ID={LocationID}
                            isLoading={isLoading}
                            dropDown={DropDowns?.Location}
                            Key={612}
                            Name={'Location'}
                            IsDeleteAllowed={IsDeleteAllowed}
                        />
                        {/* <Pagination
                            PerPage={PerPage}
                            PageNo={PageNo}
                            TotalPages={TotalPages}
                            handlePageClick={handlePageClick}
                            PreviousPage={PreviousPage}
                            handleFingByCreteria={handleFingByCreteria}
                            NextPage={NextPage}
                        /> */}
                        {paginationSection}

                    </>
                    : (
                        <div className="table-view SetupTable location_grid">
                            <Table
                                columns={columns}
                                rows={LocationData}
                                height='500px'
                                rowClass={rowClass}
                                // dynamicClass= 'fill-grid DataGrid-Table hk-exp-table'
                                dynamicClass='fill-grid DataGrid-Table hk-exp-table'
                                rowHeight={25}
                                PerPage={PerPage}
                                PageNo={PageNo}
                                TotalPages={TotalPages}
                                handlePageClick={handlePageClick}
                                PreviousPage={PreviousPage}
                                handleFingByCreteria={handleFingByCreteria}
                                NextPage={NextPage}
                                Key={612}
                                Name={'Location'}
                                isLoading={isLoading}
                                TableName={'Location'}
                                handleSelectData={handleSelectData}
                                LoadData={() => LoadData(searchParam)}
                                ClearSearch={handleClearSearch}
                            />
                        </div>
                    )
                }
            </>
        )
    }
    // useEffect(()=>{
    //     if(type && type === "Wizard"){
    //         if(LocationData?.length == 0 && isNull(searchParamType)){
    //             setIsOpenLocation(true)
    //         }       
    //     }
    // },[LocationData, searchParamType])
    return (
        <React.Fragment>
            {isLoading ? <Loader /> : null}
            {type && type === "Wizard" ?
                <>
                    <>
                        {isOpenLocation ? <>{PopupScreen}</> : <>{LocationBody()}</>}
                    </>

                </>
                :
                <>
                    {PopupScreen}
                    {LocationBody()}
                </>
            }
        </React.Fragment>
    )
}
const mapStateToProps = (state) => {
    return {
        Settings: state.SettingsReducer,
    }
}
export default connect(mapStateToProps)(Location);